/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditValidation
 */
export interface BulkEditRequestBulkEditValidation {
    /**
     * review | approved | rejected (validated and pending are set by the system)
     * @type {string}
     * @memberof BulkEditRequestBulkEditValidation
     */
    status: BulkEditRequestBulkEditValidationStatusEnum;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditValidationStatusEnum = {
    Validated: 'validated',
    Pending: 'pending',
    Review: 'review',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type BulkEditRequestBulkEditValidationStatusEnum = typeof BulkEditRequestBulkEditValidationStatusEnum[keyof typeof BulkEditRequestBulkEditValidationStatusEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditValidation interface.
 */
export function instanceOfBulkEditRequestBulkEditValidation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditValidationFromJSON(json: any): BulkEditRequestBulkEditValidation {
    return BulkEditRequestBulkEditValidationFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function BulkEditRequestBulkEditValidationToJSON(value?: BulkEditRequestBulkEditValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

